/**
 * Creatives
 * Contains the logic necessary for ad creative customization
 * version 2.2.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('creatives',[
    "jquery",
    "underscore",
    "logging",
    "utilities"
], function ($, _, logging, utilities) {
    "use strict";

    var _ModuleName = "Ad Creatives";
    var _config = {};

    /**
     * Sets up custom site skin styles and dynamic scrolling functionality
     * @param {any} config configuration object used to pull creatives config
     */
    var init = function (config) {
        ;
        $.extend(_config, config.creatives);

        ;
        window.bnm = window.bnm || {};
        window.bnm.ads = window.bnm.ads || {};

        window.bnm.ads.frameBuster = frameBuster;
    };

    /**
     * Handles frame busting to get creative outside google's iframe
      * @param {string} type Type of creative we're loading
      * @param {any} scope DOM Scope that we're working with
      * @param {any} options Any custom options that need to be passed in
     */
    var frameBuster = function (type, scope, options) {
        ;

        if (typeof type === 'undefined') {
            type = _config.frameBusting.type.skin;
        }

        // If we are not part of the top document (i.e. embedded via iFrame)
        try {
            // just a safety net to make sure we don't
            //	get stuck in an infinite loop
            var max_nodes = 100;

            ;
            var injectLocation;
            for (var i = 0; i < _config.insertLocationIds.length; i++) {
                ;
                injectLocation = top.document.getElementById(_config.insertLocationIds[i]);
                if (injectLocation) { break; }
            }

            if (injectLocation && injectLocation.nextSibling) {
                ;

                injectLocation = injectLocation.nextSibling;
                // As nodes are moved to the body, they are removed from the iFrame
                while (scope.document.body.childNodes.length > 0 && max_nodes > 0) {
                    var n = scope.document.body.childNodes[0];

                    // Scripts need to be "rebuilt" to ensure they are 
                    // executed when appended to the body
                    if (n.nodeName.toLowerCase() === "script") {
                        // jquery check - do not pull them into our pages.
                        if (n.src && /jquery.(min.)?js/i.test(n.src.toLowerCase())) {
                            n.parentNode.removeChild(n);
                            continue;
                        }

                        var script = document.createElement("script");
                        script.type = "text/javascript";

                        if (n.src) script.src = n.src;
                        if (n.text) script.text = n.text;

                        injectLocation.parentNode.insertBefore(script, injectLocation);
                        n.parentNode.removeChild(n);
                    } else { injectLocation.parentNode.insertBefore(n, injectLocation); }

                    max_nodes--;
                }
            } else {
                logging.error("Frame Busting Error: Failed to locate injection location", _ModuleName);
            }
        } catch (ex) {
            logging.error("Frame Busting Error: Exception Message - " + ex.message, _ModuleName);
        }

        ;

        if (type === _config.frameBusting.type.skin) {
            ;
            _siteSkin(options);
        } else if (type === _config.frameBusting.type.adhesion) {
            ;
            _adhesion(options);
        } else if (type === _config.frameBusting.type.overlay) {
            ;
            _overlay(options);
        } else {
            ;
        }
    };

    /**
     * Sets up custom site skin styles and dynamic scrolling functionality
     * @param {any} options Object with customized settings
     */
    var _siteSkin = function (options) {
        // make sure skin isn't already initialized
        if ($(document.body).hasClass("enable-skin")) { return; }

        ;
        ;

        // Add enable-skin class to body
        $(document.body).addClass("enable-skin");

        // Fix full width styles to use custom skin based styles
        $('.container.full-width')
            .removeClass('full-width')
            .addClass('full-width-skin');

        // Configure scroll capabilities for mobile and desktop
        var $wrapper = $('.skin-wrapper'),
            wrapperTop = $($wrapper[0]).offset().top,
            $window = $(window),
            previousScroll = 0,
            navHeight = $('#' + _config.navId).height(),
            scrollDownOffset = (utilities.IsPhone() || !_config.enableScrollingNav ? wrapperTop : navHeight),
            scrollUpOffset = (utilities.IsPhone() || !_config.enableScrollingNav ? wrapperTop : navHeight);

        var throttled = _.throttle(function () {
            if ($wrapper.length) {
                var scroll = $window.scrollTop();
                if (scroll >= (scroll > previousScroll ? scrollDownOffset : scrollUpOffset)) {
                    $wrapper.addClass("stuck");
                } else {
                    $wrapper.removeClass("stuck");
                }
                previousScroll = scroll;
            }
        }, _config.scrollThrottle);
        $window.scroll(throttled);

        // load pixels
        _loadPixels();
    };

    /**
     * Sets up custom timer and auto close functionality for adhesion ads
     * @param {any} options Object with customized settings
     */
    var _adhesion = function (options) {
        // create new copy of options based on defaults
        var opts = $.extend({}, _config.creativeConfig);

        // load any custom options passed in
        $.extend(opts, options);

        ;

        // attach the close button even
        var $skipBtn = $('#' + opts.closeBtnId);
        if ($skipBtn.length) {
            ;
            $skipBtn.click(opts, _closeOverlay);
        } else {
            logging.warn("No close button found. Unable to attach close handler.", _ModuleName);
        }

        if (opts.blurPage) {
            var wrapper = document.getElementById("SiteWrapper");
            if (wrapper) wrapper.setAttribute("class", "mobile-overlay-blur");
        }

        _loadCountdown(opts);

        // load pixels
        _loadPixels();
    };
   
    var _overlay = function (options) {
        // create new copy of options based on defaults
        var opts = $.extend({}, _config.creativeConfig);

        // load any custom options passed in
        $.extend(opts, options);

        ;

        // attach the close button even
        var $skipBtn = $('#' + opts.closeBtnId);
        if ($skipBtn.length) {
            ;
            $skipBtn.click(opts, _closeOverlay);
        } else {
            logging.warn("No close button found. Unable to attach close handler.", _ModuleName);
        }

        // load pixels
        _loadPixels();
    };

    /**
     * Closes the adhesion overlay
     * @param {any} e Event Object for the click event
     */
    var _closeOverlay = function (e) {
        e && e.stopPropagation && e.stopPropagation();
        e && e.preventDefault && e.preventDefault();

        var opts = e.data;

        ;

        var overlayElement = document.getElementById(opts.wrapperId);
        if (overlayElement) {
            overlayElement.parentElement.removeChild(overlayElement);
            if (opts.blurPage) {
                var wrapper = document.getElementById("SiteWrapper");
                if (wrapper) wrapper.setAttribute("class", "");
            }
        }
    };

    /**
     * Handling loading countdown functionality
     * @param {any} opts Options
     * */
    var _loadCountdown = function (opts) {
        // if auto close is disabled, nothing to do here
        if (opts.disableAutoClose) return;

        ;

        // if time has run out
        if (opts.autoCloseInterval <= 0) {

            // if param to disable the countdown is present, skip closing after time runs out
            if (utilities.getParameter(document.URL, 'disablecountdown') === "true")
                return;

            // Close the overlay, passing in options as data property to mimic how an event would have it
            _closeOverlay({ data: opts });

            // we're done here
            return;
        }

        // Update timer text ever second
        var $timer = $(opts.timerClass);
        if ($timer) {
            $timer.html(opts.timerPreText
                + (opts.autoCloseInterval--).toString().paddingLeft('00')
                + opts._timerPostText);

            setTimeout(_loadCountdown, 1e3);
        }
    };

    /**
     * Loads pixels after frame busting and other custom functionality is complete 
     * @param {any} scope scope of the pixels we're loading
     */
    var _loadPixels = function (scope) {
        ;

        if ($(scope).length === 0) {
            scope = $(document);
        } else {
            scope = $(scope);
        }

        var pixelContainer = $(_config.frameBusting.containers.pixels, scope);
        if (pixelContainer) {
            // loop through all defined pixels
            var pixels = pixelContainer.children('img');
            ;
            for (var i = 0; i < pixels.length; i++) {
                // check if pixel was already loaded
                var pixel = $(pixels[i]);
                if (!pixel.attr("src")) {
                    ;
                    // if not, get source data nad load pixel
                    var src = pixel.data(_config.frameBusting.data.src);
                    if (src) {
                        pixel.attr("src", src);
                    }
                }
            }
        }
    };

    return {
        init: init
    };
});
